import React from 'react';
import Header from './Header';

const Layout = ({ full = false, showAccountDropdown = true, children }) => {
    return (
        <div className="min-h-screen bg-background-dark">
            <Header type="small" showAccountDropdown={showAccountDropdown} />
            <div className={`${full ? 'w-full' : 'max-w-7xl'} mx-auto px-4 sm:px-6 lg:px-8 py-8 bg-card-background shadow-2xl rounded-xl border border-accent-main relative font-sans`}>
                <main>
                    {children}
                </main>
            </div>
        </div>
    );
};

export default Layout;
